<template>
    <v-layout fill-height column class="body-container template-padding">
        <v-container>
        <div v-for="(item, itemIndex) in items" :key="itemIndex">
            <template v-if="item.type == 'banner' && itemIndex == 0">
                <v-container class="header-container" :class="outerContainer">
                    <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
                    <v-row no-gutters align="center">
                        <v-col md="6" class="text-left header-font">
                            <div class="h2 rubik font-weight-bold" :class="$vuetify.breakpoint.smAndUp ? 'h2' : 'h3'"
                                @focusout="editableData('banner', { element: 'heading' })" :contenteditable="editableContent"
                                v-html="item.heading"
                            ></div>

                            <div class="divider" :class="$vuetify.breakpoint.smAndUp ? 'mb-3' : 'my-3'"></div>
                            <div class="h4 rubik"
                                @focusout="editableData('banner', { element: 'subtitle' })" :contenteditable="editableContent"
                                v-html="item.subtitle"
                            ></div>
                        </v-col>
                        <v-col cols="6" v-show="$vuetify.breakpoint.mdAndUp">
                            <v-img :src="item.image"></v-img>
                        </v-col>
                    </v-row>

                    <RowControls v-if="pageType == 'Canvas'" :rowIndex="itemIndex" />
                </v-container>
            </template>

            <template v-if="item.type == 'grids'">
                <Grid2 :item="item" :key="gridKey"
                    :index="itemIndex"
                    :styles="{
                        text: 'body montserrat',
                        image: {
                            contain: true,
                            wrapper: '',
                            class: '',
                            height: 'auto',
                            width: 'auto',
                            maxWidth: '100%',
                            maxHeight: '',
                            custom: {
                                margin: '0 auto'
                            }
                        },
                        heading1: {
                            wrapper: 'justify-center mt-5',
                            classMobile: 'h5 poppins font-weight-bold hd1 mb-5',
                            classLarge: 'h4 poppins font-weight-bold hd1',
                            after: 'hd1-subdivider mb-3',
								guideWrapper: '',
								guideClass: 'ml-5'
                        },
                        heading2: {
                            wrapper: '',
                            classMobile: 'h5 poppins font-weight-bold hd1',
                            classLarge: 'h4 poppins font-weight-bold hd1',
                            after: 'hd1-subdivider my-3',
								guideWrapper: '',
								guideClass: 'ml-5'
                        },
                        textcard: {
                            outlined: false,
                            elevation: 1,
                            card: 'text-center pa-5',
                            text: 'h5 rubik font-weight-bold my-3 text-center text-uppercase',
                            subtitle: 'small-text poppins text-center mt-5',
                            custom: {
                                borderRadius: '20px'
                            }
                        },
                        imagecard: {
                            doubleCard: false,
                            elevation: 1,
                            outlined: false,
                            card: 'mb-10 px-3 mt-5',
                            imagePosition: 'top',
                            image: {
                                height: '250px',
                            },
                            text: 'h5 rubik hd1-word-highlight mt-5',
                            subtitle: 'h5 poppins font-weight-bold my-6 text-center',
                            custom: {
                                borderRadius: '20px',
                            }
                        },
                        dialog: {
                            elevation: 0,
                            cardClass: 'py-5 my-5',
                            cardColor: '',
                            innerCard: '',
                            dialogTitle: '',
                            dialogName: 'rubik font-weight-bold hd1-dark-blue mr-3',
                            textWrapper: 'h5 body-poppins text-left responsive-text',
                            custom: {
                                text: '',
                                textClass: 'mt-3'
                            }
                        }
                    }"
                />
            </template>
        </div>
        </v-container>
        <ImageUploader />
    </v-layout>
</template>

<script>
import RowControls from "@/components/RowControls.vue"
import ImageUploader from "@/components/ImageUploadModal.vue"
import { Grid2 } from "@/imports/elements.js"
import { highlights } from "@/mixins/highlights"
import responsiveHeight from "@/mixins/responsiveHeight"

export default {
    props: ["items"],
    mixins: [responsiveHeight, highlights],
    components: {
        RowControls, ImageUploader, Grid2
    },
    computed: {
        bannerTextSize () {
            return this.$vuetify.breakpoint.smAndDown ? "h4" : "h3"
        }
    },
    mounted () {
        this.getRangesFromDb()
    },
    methods: {
    }
}
</script>
<style scoped>
.header-font {
  color: #05356b;
}
.header-container {
  background-color: #edfbff;
  border-radius: 20px;
}
.divider {
  background-color: #0086f5;
  width: 15%;
  height: 5px;
  border-radius: 5px;
}

.activity-container {
  /* background-image: url("../../assets/Group 46.png"); */
  background-size: 100% 100%;
}
.footer-container {
  background-color: #e9ecef;
}
</style>
